module.exports = __webpack_public_path__ + "img/13.36e50bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/13.png
// module id = 0SiP
// module chunks = 1